import { HttpClientService } from "../service/http-client.service";
import { Observable } from "rxjs";
import { ResponseOptions } from "../service/options/response.options";
import { GetOptions } from "../service/options/get.options";

export class CaptchaRepo {
  protected static getEndpointUrl(): string {
    return "/store"; // backend -> CaptchaController. We can't provide the full url, because the endpoint can be "/store/captcha ..." or "/store/api/captcha ...";
  }

  static validateCaptcha<TDataType extends BodyInit>(
    formData: TDataType,
  ): Observable<boolean> {
    const headers = new Headers();
    headers.set("Content-type", "application/x-www-form-urlencoded");

    return HttpClientService.post(
      `${this.getEndpointUrl()}/captcha/api/check`,
      formData,
      headers,
    );
  }

  static getCaptchaV2Page(): Observable<string> {
    const getOptions = new GetOptions();
    getOptions.response = new ResponseOptions();
    getOptions.response.responseType = "text";

    return HttpClientService.get(
      `${this.getEndpointUrl()}/captcha/v2/partial`,
      getOptions,
    );
  }
}
